<script setup>
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { VueMonacoEditor } from '@guolao/vue-monaco-editor';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  projectData: {
    type: Object,
    default: null
  }
});

const emit = defineEmits(['update:visible', 'save']);

// Estado local del proyecto
const localProjectJson = ref('');

// Cuando se abre el dialog o cambia el proyecto, actualizar el contenido
watch(() => props.projectData, (newProject) => {
  if (newProject) {
    localProjectJson.value = JSON.stringify(newProject, null, 2);
  }
}, { immediate: true });

// Función para cerrar el diálogo
const closeDialog = () => {
  emit('update:visible', false);
};

// Función para guardar cambios
const saveChanges = () => {
  try {
    // Parsear el JSON para validar
    const parsedProject = JSON.parse(localProjectJson.value);
    
    // Validar estructura básica
    if (!parsedProject.templates || !Array.isArray(parsedProject.templates)) {
      alert('❌ El proyecto debe tener un array "templates"');
      return;
    }
    
    if (!parsedProject.elements || !Array.isArray(parsedProject.elements)) {
      alert('❌ El proyecto debe tener un array "elements"');
      return;
    }
    
    // Emitir evento de guardado
    emit('save', parsedProject);
    emit('update:visible', false);
    
    console.log('✅ Proyecto guardado exitosamente');
  } catch (error) {
    console.error('❌ Error al parsear JSON:', error);
    alert('Error al parsear JSON: ' + error.message);
  }
};

// Opciones del editor Monaco
const editorOptions = {
  automaticLayout: true,
  formatOnType: true,
  formatOnPaste: true,
  minimap: { enabled: false },
  scrollBeyondLastLine: false,
  fontSize: 14,
  tabSize: 2,
  wordWrap: 'on'
};
</script>

<template>
  <Dialog 
    :visible="visible" 
    @update:visible="$emit('update:visible', $event)"
    modal 
    :style="{ width: '90vw', height: '90vh' }"
    header="Editor de Proyecto"
  >
    <div class="flex flex-column" style="height: calc(90vh - 120px);">
      <div class="mb-2">
        <p class="text-sm text-gray-600 mt-0 mb-2">
          Edita el JSON completo del proyecto (plantillas y elementos)
        </p>
      </div>
      
      <!-- Editor de JSON -->
      <div class="flex-1 border-1 surface-border border-round overflow-hidden">
        <VueMonacoEditor
          v-model:value="localProjectJson"
          language="json"
          :options="editorOptions"
          style="height: 100%;"
        />
      </div>
    </div>

    <template #footer>
      <div class="flex justify-content-end gap-2">
        <Button 
          label="Cancelar" 
          icon="pi pi-times" 
          @click="closeDialog" 
          severity="secondary"
          outlined
        />
        <Button 
          label="Guardar Cambios" 
          icon="pi pi-check" 
          @click="saveChanges" 
          severity="success"
        />
      </div>
    </template>
  </Dialog>
</template>

<style scoped>
/* Estilos específicos si son necesarios */
</style>
